export const style = {
  BoxRow: {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      flexShrink: 0,
      padding: '24px',
    },
  },
  BoxStatus: {
    sx: {
      px: 2,
    },
  },
  button: {
    sx: {
      display: 'flex',
      justifyContent: 'end',
      width: '100%',
      pr: 1,
    },
  },
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  title: {
    Typographyh6: {
      fontWeight: '600',
    },
    sx: {
      color: 'primary.text',
    },
  },
  subtitle: {
    sx: {
      color: 'action.active',
    },
  },
  buttonSearch: {
    sx: {
      color: 'action.active',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      '& svg': {
        width: '18px',
        height: '20px',
      },
    },
  },
  buttonDefault: {
    sx: {
      color: 'primary.main',
    },
  },
} as const;
